import { VimeoIcon, youTubeIcon, soundCloudIcon, slideShareIcon, dartfishIcon, sirvIcon, redditIcon, geniallyIcon, linedInIcon, pinterestIcon, facebookIcon, bandcampIcon, mixcloudIcon, kuulaIcon, dailyMotionIcon, twitchIcon, twitframeIcon, codepenIcon, invisionIcon, jotFormIcon,appointlyIcon, imgurIcon, giphyIcon, spotifyIcon, googleMapIcon } from './blocksIcon';

const pluginSlug = 'all-embed-addons-for-elementor';

const siteURL = 'https://elementor.bplugins.com';
const demoLink = `${siteURL}/demo`;
const docsURL = `https://bplugins.com/docs/all-embed-addons-for-elementor/widget-guides/`;

export default [

    {
        name: `bae_youtube_addon`,
        title: 'YouTube Embeder',
        icon: youTubeIcon,
        demo: `${demoLink}/youtube-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_vimeo_addon`,
        title: 'Vimeo Embeder',
        icon: VimeoIcon,
        demo: `${demoLink}/vimeo-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_soundcloud`,
        title: 'Sound Cloud Embeder',
        icon: soundCloudIcon,
        demo: `${demoLink}/soundcloud-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_invison`,
        title: 'Invision Emberder',
        icon: invisionIcon,
        demo: `${demoLink}/invision-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_jotform`,
        title: 'JotForm Embeder',
        icon: jotFormIcon,
        demo: `${demoLink}/jotform-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_google_map`,
        title: 'Google Map Embeder',
        icon: googleMapIcon,
        demo: `${demoLink}/google-map-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_appointly`,
        title: 'Appointly Embeder',
        icon: appointlyIcon,
        demo: `${demoLink}/appointly-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_spotify`,
        title: 'Spotify Embeder',
        icon: spotifyIcon,
        demo: `${demoLink}/spotify-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_giphy`,
        title: 'Giphy Embeder',
        icon: giphyIcon,
        demo: `${demoLink}/giphy-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_imgur`,
        title: 'Imgur Embeder',
        icon: imgurIcon,
        demo: `${demoLink}/imgur-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_slideshare`,
        title: 'Slide Share Embeder',
        icon: slideShareIcon,
        demo: `${demoLink}/slideshare-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_codepen`,
        title: 'Codepen Embeder',
        icon: codepenIcon,
        demo: `${demoLink}/codepen-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_twitch`,
        title: 'Twitch Embeder',
        icon: twitchIcon,
        demo: `${demoLink}/twitch-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_twitframe`,
        title: 'Twitframe Embeder',
        icon: twitframeIcon,
        demo: `${demoLink}/twitframe-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_bandcamp`,
        title: 'Bandcamp Embeder',
        icon: bandcampIcon,
        demo: `${demoLink}/bandcamp-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_dailymotion`,
        title: 'Daily Motion Embeder',
        icon: dailyMotionIcon,
        demo: `${demoLink}/dailymotion-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_dartfish`,
        title: 'Dartfish Embeder',
        icon: dartfishIcon,
        demo: `${demoLink}/dartfish-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_genial`,
        title: 'Genially Embeder',
        icon: geniallyIcon,
        demo: `${demoLink}/genially-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_sirv`,
        title: 'Sirv Embeder',
        icon: sirvIcon,
        demo: `${demoLink}/sirv-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_mixcloud`,
        title: 'Mixcloud Embeder',
        icon: mixcloudIcon,
        demo: `${demoLink}/mixcloud-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_kuula`,
        title: 'Kuula Embeder',
        icon: kuulaIcon,
        demo: `${demoLink}/kuula-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_facebook`,
        title: 'Facebook Embeder',
        icon: facebookIcon,
        demo: `${demoLink}/facebook-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_pinterest`,
        title: 'Pinterest Embeder',
        icon: pinterestIcon,
        demo: `${demoLink}/pinterest-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_linkedin`,
        title: 'Linkedin Embeder',
        icon: linedInIcon,
        demo: `${demoLink}/linkedin-embed/`,
        docs: `${docsURL}`,
    },
    {
        name: `bae_reddit`,
        title: 'Reddit Embeder',
        icon: redditIcon,
        demo: `${demoLink}/reddit-embed/`,
        docs: `${docsURL}`,
    },

];